/**
 * TotalCostOfAiTeaser — landing-page banner that re-frames "AI cost" as
 * THREE components and points to /tools/ai-cost-calculator.
 *
 * Extracted from Landing.js (Jun 2026, v34.x). ~28 lines moved out of
 * the monolith. Pure presentational — no props, no state. Visual + test
 * IDs unchanged so Playwright suites don't break.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Calculator, ArrowRight } from 'lucide-react';

export default function TotalCostOfAiTeaser() {
  return (
    <section className="px-4 sm:px-6 py-12 border-t border-white/5" data-testid="total-cost-of-ai-section">
      <div className="max-w-5xl mx-auto">
        <div className="rounded-2xl border border-white/10 bg-slate-900 p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-5">
          <div className="w-12 h-12 rounded-xl bg-emerald-500 shadow-lg shadow-emerald-500/40 flex items-center justify-center shrink-0">
            <Calculator className="w-6 h-6 text-white drop-shadow-[0_0_4px_rgba(255,255,255,0.55)]" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-[10px] font-mono uppercase tracking-[0.22em] text-emerald-300">Total Cost of AI · 2026 reality</span>
            </div>
            <h2 className="font-display text-xl sm:text-2xl font-semibold tracking-[-0.01em] text-white leading-snug">
              Your AI bill isn&apos;t one number. It&apos;s <span className="text-emerald-400">three</span>.
            </h2>
            <p className="text-[13px] text-slate-400 mt-1.5 leading-relaxed">
              Cloud LLM tokens · redundant SaaS AI · cross-cloud egress. We measure all three for your tenant.
            </p>
          </div>
          <Link
            to="/tools/ai-cost-calculator"
            data-testid="tca-calculator-cta"
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-500 hover:bg-emerald-400 text-slate-950 px-5 py-3 font-bold text-sm shadow-lg shadow-emerald-500/30 transition-all hover:-translate-y-0.5 whitespace-nowrap shrink-0"
          >
            Run the calculator
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
